// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unvergessen-avatar[data-v-a308460e]{border-radius:100px!important}", ""]);
// Exports
module.exports = exports;
